import { motion } from "framer-motion";
import { LAB_GALLERY } from "@/lib/labContent";

export function LabGallery() {
  return (
    <section className="py-14 lg:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mb-10 max-w-2xl">
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-cyan-600">Inside the lab</span>
          <h2 className="font-display mt-3 text-3xl lg:text-4xl font-bold text-slate-900 leading-[1.1]">
            Our Noosaville facility.
          </h2>
          <p className="mt-4 text-base text-slate-600 leading-relaxed">
            A close-up look at the procedures, instruments and benches behind every test we run.
          </p>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 lg:gap-4 lg:auto-rows-[180px]">
          {LAB_GALLERY.map((img, i) => (
            <motion.figure
              key={img.src}
              initial={{ opacity: 0, scale: 0.96 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.5, delay: i * 0.05 }}
              data-testid={`lab-gallery-item-${i}`}
              className={`group relative overflow-hidden rounded-2xl bg-slate-100 ${img.span}`}
            >
              <img
                src={img.src}
                alt={img.alt}
                loading="lazy"
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-slate-900/70 via-slate-900/0 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
              <figcaption className="absolute bottom-0 left-0 right-0 p-4 text-white text-xs font-semibold uppercase tracking-wider opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                {img.caption}
              </figcaption>
            </motion.figure>
          ))}
        </div>

        <p className="mt-6 text-xs text-slate-400 italic">
          Photos are representative of our testing procedures. Real facility photography available on request.
        </p>
      </div>
    </section>
  );
}
